import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import { AuthState } from "@/redux/slice/auth/types/AuthState";

const selectAuth = (state: RootState) => state?.auth;

export default createDraftSafeSelector(selectAuth, (auth: AuthState) => auth?.openLoginModal);
